import { render, staticRenderFns } from "./ParticipantStateTransition.vue?vue&type=template&id=58693aa9&"
import script from "./ParticipantStateTransition.vue?vue&type=script&lang=ts&"
export * from "./ParticipantStateTransition.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports